import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import ReactNotification from 'react-notifications-component';
import { useDispatch, useSelector } from 'react-redux';
import R from 'ramda';

import ReactGA from "react-ga4";
import { postAnalyticEvent } from '_api/analytics.js';

import { attemptGetUser } from '_thunks/user';

import SurveyPage from '_pages/SurveyPage';
import AuthPage from '_pages/AuthPage';
import LoginPage from '_pages/LoginPage';
import RegisterPage from '_pages/RegisterPage';
import HomePage from '_pages/HomePage';
import TodoPage from '_pages/TodoPage';
import SettingsPage from '_pages/SettingsPage';
import LostPage from '_pages/LostPage';

import ThankYou from '_pages/ThankYou';

import Navigation from '_organisms/Navigation';
import Footer from '_organisms/Footer';

import getQuery from '_hooks/getQuery';

export default function Main({ location }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  ReactGA.initialize("G-9QNCCY1RPR");

  const { intake, user } = useSelector(R.pick(['intake', 'user']));

  const query = getQuery();

  useEffect(() => {
    if (R.isEmpty(user) && query.get("id")) {
      //TODO automatically pull up current step or retainer

    }

    let subscribed = true;

    dispatch(attemptGetUser())
      .then(() => subscribed && setLoading(false))
      .catch(R.identity);

    return () => { subscribed = false; };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    ReactGA.send("pageview");

    postAnalyticEvent({ event: "page_view", path: '/s' + location.pathname, query: query.toString() })
      .then()
      .catch((err) => { console.log('err logging analytics') });

    if (!R.isEmpty(user)) {
      //TODO: Log User Analytics
    }

  }, [location.pathname]);

  return !loading && (
    <div>
      <ReactNotification />
      <Navigation pathname={location.pathname} />
      <div className="main">
        <Switch>
          <Route exact path="/" component={LoginPage} />
          <Route path="/s" component={SurveyPage} />
          <Route path="/auth" component={AuthPage} />
          <Route path="/login" component={LoginPage} />
          <Route path="/register" component={RegisterPage} />
          <Route path="/home" component={HomePage} />
          <Route path="/todo" component={TodoPage} />
          <Route path="/settings" component={SettingsPage} />
          <Route path="*" component={LostPage} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

Main.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};
